var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"800px","height":"800px","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"white"}}),_c('path',{attrs:{"d":"M6 12H18","stroke":"#13b5e9","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }